import { _callBackend } from '@/_api/api';
import type { APIRequest, APIResponsePromise } from '@/_types/api';

export const addClientTag = async ({
  new_tag,
  token,
}: APIRequest<{
  new_tag: string;
}>): APIResponsePromise =>
  await _callBackend(
    '/firms/add_client_tag',
    'POST',
    {
      new_tag,
    },
    token,
  );

export const removeClientTag = async ({
  tag_id,
  token,
}: APIRequest<{
  tag_id: number;
}>): APIResponsePromise =>
  await _callBackend(
    '/firms/remove_client_tag',
    'POST',
    {
      tag_id,
    },
    token,
  );

export const addEntityTag = async ({
  new_tag,
  token,
}: APIRequest<{
  new_tag: string;
}>): APIResponsePromise =>
  await _callBackend(
    '/firms/add_entity_tag',
    'POST',
    {
      new_tag,
    },
    token,
  );

export const removeEntityTag = async ({
  tag_id,
  token,
}: APIRequest<{
  tag_id: number;
}>): APIResponsePromise =>
  await _callBackend(
    '/firms/remove_entity_tag',
    'POST',
    {
      tag_id,
    },
    token,
  );

export const updateClientTags = async ({
  user_id,
  contact_tags,
  token,
}: APIRequest<{
  user_id: number;
  contact_tags: Array<string>;
}>): APIResponsePromise =>
  await _callBackend(
    '/users/update_tags',
    'POST',
    {
      contact_tags,
      user_id,
    },
    token,
  );

/**
 * @param tag_names The display names of the tags to add or remove
 * @param ids The ids of the clients to update tags for
 * @param remove If true, remove the specified tags, otherwise, add the specified tags
 * @param token The user's token
 */
export const updateBulkClientTags = async ({
  tag_names,
  ids,
  remove,
  token,
}: APIRequest<{
  ids: Array<number>;
  tag_names: Array<string>;
  remove?: boolean;
}>): APIResponsePromise =>
  await _callBackend(
    '/users/save_tags',
    'POST',
    {
      selected_tags: tag_names,
      user_ids: ids,
      remove,
    },
    token,
  );

export const updateEntityTags = async ({
  company_id,
  entity_tags,
  token,
}: APIRequest<{
  company_id: number;
  entity_tags: Array<string>;
}>): APIResponsePromise =>
  await _callBackend(
    `/companies/${company_id}/update_tags`,
    'POST',
    {
      company_id,
      entity_tags,
    },
    token,
  );

/**
 * @param tag_names The display names of the tags to add or remove
 * @param ids The ids of the entities to update tags for
 * @param remove If true, remove the specified tags, otherwise, add the specified tags
 * @param token The user's token
 */
export const updateBulkEntityTags = async ({
  tag_names,
  ids,
  remove,
  token,
}: APIRequest<{
  ids: Array<number>;
  tag_names: Array<string>;
  remove?: boolean;
}>): APIResponsePromise =>
  await _callBackend(
    '/companies/update_tags_in_bulk',
    'POST',
    {
      company_ids: ids,
      selected_tags: tag_names,
      remove,
    },
    token,
  );
